import React, {useState, useEffect} from 'react';
import DashboardHeader from '../../components/DashboardHeader';

import {calculateRange, sliceData} from '../../utils/table-pagination';

import '../styles.css';
import CategoryApi from "../../services/categories";
import CategoryTables from "./datatables";

function Categories (props) {
    const [search, setSearch] = useState('');
    const [category, setCategory] = useState([]);
    const [page, setPage] = useState(1);
    const [pagination, setPagination] = useState([]);
    const categoryApi = new CategoryApi(props.token);

    useEffect(() => {
        categoryApi.all().then((response) => {
            setCategory(sliceData(response, page, 50));
            let pages = calculateRange(response, 50);
            setPagination(pages);
        })
        .catch((err) => {
            console.error(err.message);
        });
    }, [page]);

    // Search
    const __handleSearch = (event) => {
        setSearch(event.target.value);
        if (event.target.value !== '' && category.length > 0 ) {
            let search_results = category.filter((item) =>
                item.name.toLowerCase().includes(search.toLowerCase())
            );
            setCategory(search_results);
        }
        else {
            categoryApi.all().then((response) => {
                setCategory(sliceData(response, page, 50));
            }).catch((err) => {
                console.error(err.message);
            });
        }
    };

    // Change Page 
    const __handleChangePage = (new_page) => {
        setPage(new_page);
    }

    return(
        <div className='dashboard-content'>
            <DashboardHeader
                btnText="New Category" link='/newcategory' />

            <div className='dashboard-content-container'>
                <div className='dashboard-content-header'>
                    <h2>Categories List</h2>
                    <div className='dashboard-content-search'>
                        <input
                            type='text'
                            value={search}
                            placeholder='Search..'
                            className='dashboard-content-input'
                            onChange={e => __handleSearch(e)} />
                    </div>
                </div>

               <CategoryTables token={props.token} category={category}/>

                {category.length !== 0  ?
                <div>
                    {
                       pagination && pagination.length > 1 && <div className='dashboard-content-footer'>
                        {pagination.map((item, index) => (
                            <span 
                                key={index} 
                                className={item === page ? 'active-pagination' : 'pagination'}
                                onClick={() => __handleChangePage(item)}>
                                    {item}
                            </span>
                        ))}
                    </div>
                    }
                </div>
                : 
                    <div className='dashboard-content-footer'>
                        <span className='empty-table'>No data</span>
                    </div>
                }
            </div>
        </div>
    )
}

export default Categories;